import { createRouter, createWebHistory } from 'vue-router'
import HomeView from './views/HomeView.vue'
import CoursesView from './views/CoursesView.vue'
import CourseDetailView from './views/CourseDetailView.vue'
import CustomsView from './views/CustomsView.vue'
import ForumView from './views/ForumView.vue'
import AccountView from './views/AccountView.vue'
import LecturerView from './views/LecturerView.vue'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/courses', name: 'courses', component: CoursesView },
    { path: '/courses/:id/learn/:lesson?', name: 'course-player', component: () => import('./views/CoursePlayerView.vue'), props: true },
    { path: '/courses/:id', name: 'course-detail', component: CourseDetailView, props: true },
    { path: '/lecturers/:id', name: 'lecturer-detail', component: LecturerView, props: true },
    { path: '/customs', name: 'customs', component: CustomsView },
    { path: '/forum', name: 'forum', component: ForumView },
    { path: '/account', name: 'account', component: AccountView },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
})

export default router
